<ng-container *clientScreen="let isDesktop = isDesktop">
	<pre>{{ opened }}</pre>
	@if (opened) {
		<div
			moveToRoot
			class="backdrop pt-safe-t pr-safe-r pb-safe-b pl-safe-l top-0 left-0 w-full h-full fixed box-border backdrop-menu"
			(click)="outsideClick()"
		>
			<div class="w-full h-full flex items-center justify-center whitespace-pre-line">
				<div
					class="modal-panel bg-180 shadow-z-menu flex flex-col items-center justify-start scrollbar-fade overflow-auto"
					[class.desktop]="isDesktop"
					[class.full-size]="fullSize"
					[class.mobile]="!isDesktop"
					(click)="$event.stopPropagation()"
				>
					<div class="flex-none w-full h-4 flex items-center justify-end">
						@if (showClose) {
							<button uiNewButtonIcon size="SMALL" (click)="close()">
								<i class="icon-cross-close"></i>
							</button>
						}
					</div>
					<div class="flex-auto w-full scrollbar-fade overflow-auto">
						<ng-content></ng-content>
					</div>
					<div
						class="flex-none w-full flex items-center box-border"
						[class]="!isDesktop ? 'py-1.25' : ''"
						[class.px-4]="!isDesktop"
						[class.justify-center]="!isDesktop"
						[class.justify-end]="isDesktop"
					>
						<ng-content select="[footer]"></ng-content>
					</div>
				</div>
			</div>
		</div>
	}
</ng-container>
